/* @flow */
import OrganizationPicker from './OrganizationPicker';

export default OrganizationPicker;
